import { CompanySummary } from '@/gen/inventory/v1/company_summary_pb'

import { cn } from '@/lib/ui/style-helpers'
import { buildThirdPartyUrl } from '@/lib/url/urls'

import { RiskBadge } from '@/components/shared/risk-badge/risk-badge'
import { getInherentRisk } from '@/components/shared/risk-badge/utils'

type CompanySummaryBadgeProps = {
  companySummary: CompanySummary
  disableAction?: boolean
}

export const CompanySummaryBadge = ({
  companySummary: { validatedRisk, calculatedRisk, profileName, companyId },
  disableAction = false,
}: CompanySummaryBadgeProps) => {
  const risk = getInherentRisk(validatedRisk, calculatedRisk)
  return (
    <div
      onClick={() => !disableAction && window.open(buildThirdPartyUrl(companyId), '_blank')}
      className={cn('flex flex-col', {
        'cursor-pointer': !disableAction,
      })}
    >
      <div className='flex items-center gap-2'>
        <RiskBadge riskLevel={risk} size='icon' />
        <h2 className='text-nowrap text-main-foreground-primary text-label-default'>
          {profileName}
        </h2>
      </div>
    </div>
  )
}
